var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_370_5999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_370_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17188 14.1641H10.8385V9.16406H9.17188V14.1641ZM10.0052 7.4974C10.2413 7.4974 10.4392 7.41753 10.599 7.25781C10.7587 7.09809 10.8385 6.90017 10.8385 6.66406C10.8385 6.42795 10.7587 6.23003 10.599 6.07031C10.4392 5.91059 10.2413 5.83073 10.0052 5.83073C9.7691 5.83073 9.57118 5.91059 9.41146 6.07031C9.25174 6.23003 9.17188 6.42795 9.17188 6.66406C9.17188 6.90017 9.25174 7.09809 9.41146 7.25781C9.57118 7.41753 9.7691 7.4974 10.0052 7.4974ZM10.0052 18.3307C8.85243 18.3307 7.7691 18.112 6.75521 17.6745C5.74132 17.237 4.85938 16.6432 4.10938 15.8932C3.35937 15.1432 2.76562 14.2613 2.32812 13.2474C1.89062 12.2335 1.67188 11.1502 1.67188 9.9974C1.67188 8.84462 1.89062 7.76128 2.32812 6.7474C2.76562 5.73351 3.35937 4.85156 4.10938 4.10156C4.85938 3.35156 5.74132 2.75781 6.75521 2.32031C7.7691 1.88281 8.85243 1.66406 10.0052 1.66406C11.158 1.66406 12.2413 1.88281 13.2552 2.32031C14.2691 2.75781 15.151 3.35156 15.901 4.10156C16.651 4.85156 17.2448 5.73351 17.6823 6.7474C18.1198 7.76128 18.3385 8.84462 18.3385 9.9974C18.3385 11.1502 18.1198 12.2335 17.6823 13.2474C17.2448 14.2613 16.651 15.1432 15.901 15.8932C15.151 16.6432 14.2691 17.237 13.2552 17.6745C12.2413 18.112 11.158 18.3307 10.0052 18.3307ZM10.0052 16.6641C11.8663 16.6641 13.4427 16.0182 14.7344 14.7266C16.026 13.4349 16.6719 11.8585 16.6719 9.9974C16.6719 8.13628 16.026 6.5599 14.7344 5.26823C13.4427 3.97656 11.8663 3.33073 10.0052 3.33073C8.1441 3.33073 6.56771 3.97656 5.27604 5.26823C3.98438 6.5599 3.33854 8.13628 3.33854 9.9974C3.33854 11.8585 3.98438 13.4349 5.27604 14.7266C6.56771 16.0182 8.1441 16.6641 10.0052 16.6641Z",
    fill: "#F71111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4b9972c01c8758e23838472f05f44efe.svg";
export { ForwardRef as ReactComponent };